import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'empathy-hashtag',
  templateUrl: './hashtag.component.html',
  styleUrls: ['./hashtag.component.scss']
})
export class HashtagComponent {
  @Input() hashtag: string;

  @Output() clicked = new EventEmitter<string>();
}
